// extracted by mini-css-extract-plugin
export default {"icon":"fqECKp3xYbWgqUg6lZNj"};